document.addEventListener("DOMContentLoaded", () => {
    const swiperContainer = document.querySelector('.cv-chrono-carrousel');

    if (!swiperContainer) return;

    const contentCarrouselSwiper = new Swiper('.cv-chrono-carrousel--swiper', {
        loop: false,
        slidesPerView: 'auto',
        spaceBetween: 12,

        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
        },

        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

        on: {
            slideChange: function () {
                activateByIndex(this.activeIndex);
            }
        }
    });

    console.log(contentCarrouselSwiper);

    const blocks = document.querySelectorAll('.cv-event-content');
    const slides = document.querySelectorAll('.swiper-slide');

    function activateByIndex(index) {
        blocks.forEach(block => {
            block.classList.remove('active', 'tw-opacity-100');
            block.classList.add('tw-opacity-40');
        });
        slides.forEach(slide => slide.classList.remove('active'));

        const activeBlock = document.querySelector(`.cv-event-content[data-slide-index="${index}"]`);
        const activeSlide = document.querySelector(`.swiper-slide[data-slide-index="${index}"]`);

        if (activeBlock) {
            activeBlock.classList.add('active', 'tw-opacity-100');
            activeBlock.classList.remove('tw-opacity-40');
        }

        if (activeSlide) {
            activeSlide.classList.add('active');
        }
    }

    blocks.forEach(block => {
        const h3 = block.querySelector('.cv-event-content__title');

        if (h3) {
            h3.addEventListener('click', () => {
                const index = parseInt(block.getAttribute('data-slide-index'), 10);
                contentCarrouselSwiper.slideTo(index);
                activateByIndex(index);
            });
        }
    });

    slides.forEach(slide => {
        slide.addEventListener('click', () => {
            const index = parseInt(slide.getAttribute('data-slide-index'), 10);
            contentCarrouselSwiper.slideTo(index);
            activateByIndex(index);
        })
    })
});